// Interfaces
import { IMyDocumentTableFooterProps } from "./interface"

// Components
import { BaseTableFooter, BaseLabel } from 'components'

// Antd
import { Row, Col } from "antd"

// i18n
import { useTranslation } from 'react-i18next'

const MyDocumentTableFooter = ({onChange, loading, data}: IMyDocumentTableFooterProps ) => {
  const { t } = useTranslation()
  return <>
    {/* Total Poin Kum */}
    <Row justify="end" className="mt-4" align="middle">
      <Col>
        <BaseLabel label={`${t('myDocument.totalPoinKum')}: ${data.totalPoinKum}`} fontSize={14} isBold />
      </Col>
    </Row>

    {/* Pagination Info */}
    <BaseTableFooter onChange={onChange} loading={loading} data={data} />
  </>
}

export { MyDocumentTableFooter }